import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

interface Activity {
  id: string;
  name: string;
  action: string;
  time: string;
  avatar: string;
  color: string;
}

const activities: Activity[] = [
  {
    id: "1",
    name: "Tinashe",
    action: "enrolled in Video Editing 101",
    time: "2 minutes ago",
    avatar: "T",
    color: "#7c3aed",
  },
  {
    id: "2",
    name: "Lisa",
    action: "completed Lighting Basics",
    time: "15 minutes ago",
    avatar: "L",
    color: "#ec4899",
  },
  {
    id: "3",
    name: "Mike D",
    action: "submitted review for Live Streaming Masterclass",
    time: "1 hour ago",
    avatar: "M",
    color: "#8b5cf6",
  },
  {
    id: "4",
    name: "Rebecca M",
    action: "uploaded new module to Advanced Camera Work",
    time: "2 hours ago",
    avatar: "R",
    color: "#3b82f6",
  },
  {
    id: "5",
    name: "Trevor",
    action: "passed assessment in Video Editing 101",
    time: "3 hours ago",
    avatar: "T",
    color: "#10b981",
  },
  {
    id: "6",
    name: "Xavi",
    action: "enrolled in Lighting Basics",
    time: "4 hours ago",
    avatar: "X",
    color: "#f59e0b",
  },
];

export default function RecentActivities() {
  return (
    <Card sx={{ height: "100%", boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 0.5 }}>
          Recent Activities
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Latest student actions
        </Typography>

        <List sx={{ p: 0 }}>
          {activities.map((activity, index) => (
            <ListItem
              key={activity.id}
              sx={{
                px: 0,
                py: 1,
              }}
            >
              <Box sx={{ display: "flex", gap: 1.5, width: "100%" }}>
                <Avatar
                  sx={{
                    bgcolor: `${activity.color}20`,
                    color: activity.color,
                    width: 40,
                    height: 40,
                    fontSize: "0.875rem",
                    fontWeight: 600,
                  }}
                >
                  {activity.avatar}
                </Avatar>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      mb: 0.5,
                      lineHeight: 1.5,
                    }}
                  >
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      {activity.name}
                    </Box>{" "}
                    {activity.action}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {activity.time}
                  </Typography>
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
